import Grid from "@mui/material/Grid";
import { useAppServices } from "hook/services";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useState } from "react";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import AccounTab from "./components/Tabs/AccountTab";
import ContactTab from "./components/Tabs/ContactTab";
import Links from "./components/Tabs/Links";
import Attachments from "./components/Tabs/Attachments";
import SocialUrl from "./components/Tabs/SocialUrl";
import Reviews from "./components/Tabs/Reviews";
import BusinessHours from "./components/Tabs/BusinessHours";
import Blogs from "./components/Tabs/Blogs";
import Team from "./components/Tabs/Team";
import NewsFeed from "./components/Tabs/NewsFeed";
import Analaytics from "./components/Tabs/Analaytics";
import JobsTab from "./components/Tabs/JobsTab";
import Events from "./components/Tabs/Events";
import SoftTypography from "components/SoftTypography";
import CustomTabs from "../components/CustomTabs";
import GoogleImages from "./components/Tabs/GoogleImages";
import { useAgencyInfo } from "context/agency";

function AccountDetail() {
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const [formData, setformData] = useState({});
  console.log(formData,"formDataformDataformDataformDataformData")
  const onLoad = async () => {
    const url = window.location.href;
    const parts = url.split("/"); // Split the URL by '/'
    const lastPart = parts[parts.length - 1]; // Get the last part of the URL
    const { response } = await AppService.accounts.getbyid({
      query: `id=${lastPart}&agency_id=${agency?._id}`,
    });
    if (response) {
      setformData(response.data);
    }
  };
  useEffect(() => {
    onLoad();
  }, []);

  const businessHourFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Business Hour Configurations"
  );
  const TeamsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Teams"
  );
  const AttachmentFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Featured Image"
  );
   const blogsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Blogs"
  );
  const eventsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Events"
  );
  const jobsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Jobs"
  );
  const newsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "News Feeds"
  );

  const ExtraLinkFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Extra Links"
  );

  const SocialMediaFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Social Media"
  );

   const ReviewsFeature = formData?.plan?.features?.find(
    (feature) => feature.name === "Reviews"
  );

  let tabsData = [
    { label: "Analytics", content: <Analaytics handleRefresh={onLoad} formData={formData} /> },
    { label: "Account Owner", content: <AccounTab handleRefresh={onLoad} formData={formData} /> },
    {
      label: "Business details",
      content: <ContactTab handleRefresh={onLoad} formData={formData} />,
    },
    
  ];

  if(blogsFeature?.value){
       tabsData.push(
        { label: "Blogs", content: <Blogs handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(eventsFeature?.value){
       tabsData.push(
         { label: "Events", content: <Events handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(jobsFeature?.value){
       tabsData.push(
         { label: "Jobs", content: <JobsTab handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(newsFeature?.value){
       tabsData.push(
         { label: "News Feed", content: <NewsFeed handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(ReviewsFeature?.value){
       tabsData.push(
        { label: "Reviews", content: <Reviews handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(businessHourFeature?.value){
       tabsData.push(
        {
      label: "Business Hours",
      content: <BusinessHours handleRefresh={onLoad} formData={formData} />,
    },
       )
  }
  if(TeamsFeature?.value){
       tabsData.push(
        { label: "Team", content: <Team handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(AttachmentFeature?.value){
       tabsData.push(
        { label: "Additional Images", content: <Attachments handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(ExtraLinkFeature?.value){
       tabsData.push(
        { label: "Links", content: <Links handleRefresh={onLoad} formData={formData} /> },
       )
  }
  if(SocialMediaFeature?.value){
       tabsData.push(
        { label: "Social Urls", content: <SocialUrl handleRefresh={onLoad} formData={formData} /> },
       )
  }
  return (
    <PageLayout>
      <SoftBox alignItems="center">
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <SoftTypography
              variant={"h2"}
              textTransform="capitalize"
              fontWeight="600"
            >
              Business
            </SoftTypography>
            <span style={{ fontSize: "14px", cursor: "pointer" }} onClick={() => navigate(-1)}>
              {" "}
              {"Business"} {`>`}
            </span>{" "}
            <span style={{ fontSize: "14px" }}> {formData?.first_name}</span>
            <h1 className=" my-3percent headingpage-branding">
              {formData?.first_name}{" "}
              <span className="alert-success-new">
                {formData?.plan_type === "premium" ? formData?.plan_type : "Free"}
              </span>
            </h1>
            <CustomTabs tabsData={tabsData} />
            {/* <SoftUITabs tabsData={tabsData} /> */}
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

export default AccountDetail;
